function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#373A36;}\n\t.st1{fill:#9C4877;}\n\t.st2{fill:#F8F8F7;}\n\t.st3{fill:#E2E2DC;}\n\t.st4{fill:#E64B38;}\n\t.st5{fill:#EFB8A9;}\n\t.st6{fill:none;stroke:#CCCCCC;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st7{fill:#FFC557;}\n\t.st8{fill:none;stroke:#373A36;stroke-width:0.4213;stroke-miterlimit:10;}\n\t.st9{fill:#4A9462;}\n\t.st10{fill:none;stroke:#F8F8F7;stroke-width:0.5;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M10.887,18.643c5.14,0,9.321-4.182,9.321-9.322c0-5.14-4.182-9.321-9.321-9.321S1.565,4.182,1.565,9.321 C1.565,14.461,5.747,18.643,10.887,18.643z M10.887,0.5c4.864,0,8.821,3.957,8.821,8.821s-3.957,8.822-8.821,8.822 s-8.821-3.958-8.821-8.822S6.022,0.5,10.887,0.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M10.887,21.212c-6.002,0-10.886,4.883-10.886,10.886L0,36.935h0.5l0.001-4.837 c0-5.727,4.659-10.386,10.386-10.386s10.386,4.659,10.386,10.386l-0.002,4.837h0.5l0.002-4.837 C21.772,26.096,16.889,21.212,10.887,21.212z"
}));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.772 36.935",
    style: {
      enableBackground: "new 0 0 21.772 36.935"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.b292f277.svg";
export { ForwardRef as ReactComponent };